import { DuplicateStatus } from "web/constants/benefits";

import { IDuplicateFormData } from "web/types/Subscription";

export const prepareDuplicateOrderStatus = (
  benefitFormsWithDuplicateStatus: IDuplicateFormData,
  prevState: IDuplicateFormData[]
) => {
  if (benefitFormsWithDuplicateStatus) {
    const newState = prevState.filter(
      (ele: IDuplicateFormData) => ele.id !== benefitFormsWithDuplicateStatus.id
    );

    const newDuplicateInfo = {
      ...benefitFormsWithDuplicateStatus,
      duplicateOrderStatus: DuplicateStatus.ALREADY_ORDERED,
    };

    return [...newState, newDuplicateInfo];
  }

  return prevState;
};

export default prepareDuplicateOrderStatus;
